/**
 * Copyright (C) 2019 Egylis,
 * Siège social, 83 bis rue de l'Abbé Groult, 75015 Paris - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created on Mon Feb 28 2022 16:48:22 GMT+0100 (heure normale d’Europe centrale).
 *
 * Version : Generator 2.0.9 / Datatable 1.0.1
 */

import {
    MOEntityMeta,
    ArbreMachineMeta,
    ArbreTravailMeta,
    FilterValueMeta,
    I18nMeta,
    MachineMeta,
    MediaMeta,
    RouleauMeta,
    RouleauDocMeta,
    RouleauI18nMeta,
    RouleauNoteMeta,
    TravailMachineMeta,
} from './metaEntity';

import {MOEntity} from './entity';

/**
 * Mpa Constants
 */
export class MpaConstants {
    /**
     * Entity Classes.
     */
    public static META_ENTITY_CLASSES: Array<MOEntityMeta<MOEntity>> = [
        new ArbreMachineMeta(),
        new ArbreTravailMeta(),
        new FilterValueMeta(),
        new I18nMeta(),
        new MachineMeta(),
        new MediaMeta(),
        new RouleauMeta(),
        new RouleauDocMeta(),
        new RouleauI18nMeta(),
        new RouleauNoteMeta(),
        new TravailMachineMeta(),
    ];
    /**
     * Dexie Name
     */
    public static DEXIE_NAME: string = 'MoMPA';
    /**
     * Dexie Version
     */
    public static DEXIE_VERSION: number = 4;


}
